import { useEffect, useState } from "react";
import TeamInfoEdit from "./team-info-edit";
import { TeamInfoDisplay } from "./team-info-display";
import { Button } from "../../../components/button";
import { useNavigate, useLocation } from "react-router-dom";
import { TeamWithDetails } from "../../../types/team.types";

export interface ITeamInfoPrimaryUserProps {
  team: TeamWithDetails;
}

export function TeamInfoPrimaryUser({ team }: ITeamInfoPrimaryUserProps) {
  const [isEditing, setIsEditing] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleHashChange = () => {
      setIsEditing(location.hash === "#edit");
    };

    window.addEventListener("hashchange", handleHashChange);
    handleHashChange();

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [location.hash]);

  const handleEdit = () => {
    navigate("#edit");
  };

  return (
    <div>
      {isEditing ? (
        <TeamInfoEdit onCancel={() => navigate("#")} team={team} />
      ) : (
        <div>
          <TeamInfoDisplay team={team} />
          <Button
            onClick={handleEdit}
            text="Editar"
            variant="edit"
            className="mt-4"
          />
        </div>
      )}
    </div>
  );
}
